/** Save-time persistence for exec metric overrides (CONF-212, spec §5).
 *  Fail-closed like persistCustomPricing: the audit event is written first and
 *  the caller's createQuote only proceeds on ok. No separate exec-only record —
 *  the overrides ride on the quote row so a reloaded quote shows the same
 *  numbers the customer saw, for every user. */
import { hasMetricOverrides } from '../domain/MetricsOverrides';
import { buildMetricsPersistEvent } from './execMetricsAudit';
import { recordEscapeEvent } from './execPricingAudit';

export async function persistCustomMetrics({ quoteId, execMetrics, config, actor, vendorId, appVersion, savedAt }) {
  if (!execMetrics || !hasMetricOverrides(execMetrics.overrides)) return { ok: true, customMetrics: null };

  const event = buildMetricsPersistEvent({ execMetrics, config, quoteId, actor, vendorId, appVersion, savedAt });
  if (!(await recordEscapeEvent(event))) return { ok: false, customMetrics: null };

  return {
    ok: true,
    customMetrics: {
      overrides: JSON.stringify(execMetrics.overrides),
      keys: Object.keys(execMetrics.overrides),
      savedAt,
      appVersion,
    },
  };
}
